<template>
  <div class="container g-flex g-row-center">
    <div class="total-width white-bg g-m-t-30">
      <div class="g-p-30 g-flex g-col-top">
        <!--  左侧信息  -->
        <div class="left-info g-p-b-30 g-rela">
          <div class="title g-rela g-flex g-row-center g-weight-font g-font-24">
            线上实操考试
          </div>
          <!--  考核中  -->
          <p class="yellow-text g-text-center g-font-30 g-weight-font" v-if="status === 3">考核中</p>

          <!--  考核合格  -->
          <div class="g-m-t-20 g-text-center"  v-if="status === 1">
            <p class="green-text g-font-30 g-weight-font">合格</p>
            <p class="green-text  g-m-t-20 g-font-14 ">恭喜您考试合格,获得2星证书</p>
          </div>

          <!--  考核不合格  -->
          <div class="g-m-t-20 g-text-center"  v-if="status === 2">
            <p class="red-text g-font-30 g-weight-font">不合格</p>
            <p class="red-text  g-m-t-20 g-font-14 ">考核不通过理由：请上传清晰的视频</p>

          </div>

          <!--  分割线  -->
          <div class="dash-line g-m-t-35"></div>
          <div class="g-flex g-row-center">
            <div>
              <div class="g-m-t-40 g-flex">
                <img src="@/assets/examination/subjects-icon.png" class="left-icon" alt="">
                <p class="g-m-l-15">科目：口腔执业医师</p>
              </div>
              <div class="g-m-t-15 g-flex">
                <img src="@/assets/examination/level-icon.png" class="left-icon" alt="">
                <p class="g-m-l-15">等级：初级</p>
              </div>
            </div>
          </div>
        </div>

        <!--  右侧上传  -->
        <div class="g-m-l-70 right-container">
          <div class="g-flex ">
            <span class="blue-point"></span>
            <p class="g-m-l-10 main-text g-font-22">请上传实操视频</p>
          </div>
          <div class="g-m-l-18">
            <div class="g-flex g-m-t-20">
              <!--  上传的视频  -->
              <div class="g-rela " @mouseenter="doAnimate" @mouseleave="endAnimate">
                <div class="mask pointer g-flex g-row-center " v-if="isHover" @click="playVideo">
                  <img src="@/assets/find-careers/play-btn.png" v-if="!isPlaying" @click="playVideo" class="play-btn" alt="">
                </div>
                <video v-if="videoSrc" id="media" poster="../../assets/examples/02.png" height="150px" width="240px" preload>
                  <source :src="videoSrc" type="video/mp4">
                </video>
              </div>
            </div>

            <div class="g-m-t-50 g-font-16">
              <!--  不合格  -->
              <div class="g-flex" v-if="status === 2">
                <div class="btn btn2">重新考试</div>
                <div class="btn btn1 g-m-l-30" @click="toTestDetail">返回考试详情</div>
              </div>
              <!--  合格  -->
              <div class="g-flex" v-if="status === 1">
                <div class="btn btn2" @click="toTestDetail">返回考试详情</div>
                <div class="btn btn1 g-m-l-30" @click="showCert">查看证书</div>
              </div>

              <!--  合格  -->
              <div class="g-flex" v-if="status === 3">
                <div class="btn btn1" @click="toTestDetail">返回考试详情</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "online-operation",
  data(){
    return{
      status:1,//1:已通过 2:未通过 3:考核中
      isHover:false,
      isPlaying:false,
      videoSrc:'https://www.w3school.com.cn/i/movie.mp4',//视频上传地址
    }
  },
  mounted() {
    this.initVideo()
  },
  methods:{
    initVideo() {
      this.videoEl = document.getElementById('media')
    },
    //鼠标移入的事件
    doAnimate(){
      setTimeout(()=>{
        this.isHover = true
      },100)
    },
    //  鼠标移除事件
    endAnimate(){
      setTimeout(()=>{
        this.isHover = false
      },100)
    },
    //  播放视频
    playVideo(){
      this.isPlaying = true
      this.videoEl.play()
    },
    showCert(){
      this.$router.push({
        name:"mine",
        query: {
          menuIndex:6,
        }
      })
    },
    toTestDetail(){
      this.$router.push({
        name:"written-test-detail",
        query: {
          paperId:this.examData.paperId,
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.white-bg{
  border-radius: 5px;
  background: #fff;
}

.left-info{
  background: #f6f6f8;
  border-radius: 5px;
  padding:0 30px;
  width: 393px;

  .title{
    background-image: url("../../assets/course-list/course-title-bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 306px;
    height: 91px;
    color: #fff;
    margin: -20px auto 0 auto;
  }

  .left-icon{
    width: 35px;
    height: 35px;
  }

  .dash-line{
    border-top: 1px dashed #407aff;
    width: 100%;
  }
}

.right-container{

  .blue-point{
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #407AFF;
  }

  .upload-img{
    width: 150px;
    height: 150px;
  }


  .mask{
    background: rgba(0,0,0,0.5);
    position: absolute;
    top: 0;
    left: 0;
    width: 240px;
    height: 150px;
    cursor: pointer;
  }

  .del-img{
    width: 39px;
    height: 39px;
  }

  video{
    width: 240px;
    height: 150px;
    object-fit: fill;
  }

  .btn{
    border-radius: 5px;
    width: 130px;
    height: 40px;
    @extend .g-flex;
    @extend .g-row-center;
  }

  .btn1{
    color: #407AFF;
    background: #F6F6F8;

    &:hover{
      background: #407AFF;
      color: #fff;
    }
  }

  .btn2{
    color: #fff;
    background: #407AFF;
    &:hover{
      background: rgba($color: #407AFF, $alpha: 0.8);
      color: #fff;
    }
  }
}


</style>